<style scoped lang="stylus" rel="stylesheet/stylus"></style>

<template>
	<div>
		<slot :user11="user">{{ user.lastName }}</slot>
		<slot name="cat" :cat11="cat">{{ cat.name }}</slot>
	</div>
</template>

<script>
export default {
	name: 'currentUser',
	components: {},
	props: {},
	data() {
		return {
			user: {
				firstName: 'lei',
				lastName: 'zhang'
			},
			cat: {
				name: 'mimi',
				age: '3'
			}
		}
	}
}
</script>
